export default "<div class=\"redirect\"><h1>Redirecting to login page ...</h1></div>\r\n"